import React, { FC } from "react";
import { ListItem, Box, Avatar, makeStyles } from "@material-ui/core";
import { Project, ProjectType } from "domain-entities";
import { getColorHex } from "Helpers/ColorHelper";
import { px, color } from "Configs/theme";
import FolderIcon from "@material-ui/icons/Folder";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import {
	getProjectAddressString,
	getProjectContactsString,
} from "./ProjectHelper";

interface Props {
	project: Project;
	onClick: (project: Project) => void;
}

const ProjectListItem: FC<Props> = (props) => {
	const classes = useStyles();
	const addressString = getProjectAddressString(props.project);
	const contactsString = getProjectContactsString(props.project);

	function renderAvatar() {
		if (props.project.projectType === ProjectType.FOLDER) {
			return (
				<Box className={classes.folder}>
					<FolderIcon
						fontSize="large"
						htmlColor={getColorHex(props.project.colorTag)}
					/>
				</Box>
			);
		} else {
			return (
				<Avatar
					style={{
						backgroundColor: getColorHex(props.project.colorTag),
					}}
				>
					{props.project.name.charAt(0)}
				</Avatar>
			);
		}
	}

	function renderChevron() {
		if (props.project.projectType === ProjectType.FOLDER) {
			return (
				<Box className={classes.chevron}>
					<ChevronRightIcon fontSize="large" />
				</Box>
			);
		}
	}

	return (
		<ListItem
			button
			className={classes.listItem}
			onClick={() => props.onClick(props.project)}
		>
			{renderAvatar()}
			<Box className={classes.content}>
				<Box className={classes.name}>{props.project.name}</Box>
				{contactsString && (
					<Box className={classes.subline}>{contactsString}</Box>
				)}
				{addressString && (
					<Box className={classes.subline}>{addressString}</Box>
				)}
			</Box>
			{renderChevron()}
		</ListItem>
	);
};

export default ProjectListItem;

const useStyles = makeStyles({
	listItem: {
		display: "flex",
		flex: 1,
		alignItems: "center",
		padding: `${px.s} ${px.m}`,
	},
	content: {
		display: "flex",
		flex: 1,
		flexDirection: "column",
		marginLeft: px.m,
		width: 0, // needed for ellipsis text overflow
	},
	name: {
		textTransform: "uppercase",
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		fontWeight: "bold",
	},
	subline: {
		height: "18px",
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		fontSize: "12px",
		color: color.lightText,
		marginTop: px.xxs,
	},
	chevron: {
		display: "flex",
		flexDirection: "column",
		marginLeft: px.m,
	},
	folder: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: 40,
		height: 40,
	},
});
